(function () {
    if (!gatedPageInfo) {
        return;
    }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // eBooks
    let formConfigs = {
        formId: 'fb5dbf56-0002-4eaa-a3ce-6ec3b4ea693b',
        urlField: 'visited_gated_ebook_url',
        nameField: 'visited_gated_ebook_name'
    };

    if (gatedPageInfo.type.includes('webinar')) {
        // Webinars
        formConfigs = {
            formId: '7f37f7bb-1228-47e9-82ba-580b86eb8205',
            urlField: 'visited_gated_webinar_url',
            nameField: 'visited_gated_webinar_name'
        };
    }

    const fields = [{
        "objectTypeId": "0-1",
        "name": formConfigs.nameField,
        "value": gatedPageInfo.title,
    }, {
        "objectTypeId": "0-1",
        "name": formConfigs.urlField,
        "value": gatedPageInfo.url,
    }
    ];

    const raw = JSON.stringify({
        "fields": fields,
        "context": {
            "hutk": getCookie('hubspotutk'), // ":hutk", // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
            "pageUri": window.location.href,
            "pageName": window.document.title
        },
    });

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        // redirect: 'follow'
    };

    fetch("https://api.hsforms.com/submissions/v3/integration/submit/5129222/" + formConfigs.formId, requestOptions)
        .then(response => response.text())
        .then(result => {
            console.log(result);
        })
        .catch(error => console.log('error', error));


    /**
     * Functions
     */

    function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
})();